import { GameWorker } from "./gameWorker";
import * as PIXI from "pixi.js";
import { GraphicalWorld } from "./clientInjector";
import geckos from "@geckos.io/client";
import { io } from "socket.io-client";

window.PIXI = PIXI;

let channel = { emit: () => { }, on: () => { } };

let connected = false;

let targetServerURL = null;
let targetServerPort = 3000;

function connectWS(url) {
    targetServerURL = url;
    connected = false;
    try {
        channel.close();
    } catch (error) { }

    console.log(`New server connection (WebSocket): ${url}`);

    if (url && url !== "localsocket") {
        channel = io(url);
    } else {
        channel = io();
    }

    try {
        gameWorker.socket = channel;
        gameWorker.reset();
    } catch (error) { }

    channel.on("disconnect", () => {
        gameWorker.reset();
    });
}

function connect(url, port) {
    targetServerURL = url;
    targetServerPort = port;
    if (url && (url === "localsocket" || url.startsWith("ws://") || url.startsWith("wss://"))) {
        connectWS(url);
        return;
    }
    console.log(`New server connection (WebRTC): ${url == null ? "-" : url}:${port}`);
    connected = false;
    try {
        channel.close();
    } catch (error) { }

    const data = {};
    if (url && url.trim() !== "") {
        data.url = url;
    }
    if (port && (typeof (port) !== "string" || port.trim() !== "")) {
        data.port = port;
    }
    channel = geckos(data);

    channel.onConnect(error => {
        connected = true;
        if (error) {
            console.error(error.message);
            return;
        }
        console.log("Connected to the server");
    });

    try {
        gameWorker.socket = channel;
        gameWorker.reset();
    } catch (error) { }

    channel.onDisconnect(() => {
        connected = false;
        if (targetServerURL === url && targetServerPort === port) connect(targetServerURL, targetServerPort);
        gameWorker.reset();
    });
}

//connect(null, 3000);

async function getServers(jsonPath = "servers.json") {
    try {
        const data = await (await fetch(jsonPath, { signal: AbortSignal.timeout(5000) })).json();
        const extra = [];
        const toRemove = [];
        for (let i = 0; i < data.length; i++) {
            const serverData = data[i];
            if (serverData.remote) {
                toRemove.push(i);
                let remoteServers = null;
                try {
                    remoteServers = await getServers(serverData.remote);
                } catch(err) {
                    console.warn("Could not get remote servers:", e);
                }
                if (remoteServers) {
                    extra.push(...remoteServers);
                }
            }
        }
        for (let i = toRemove.length - 1; i >= 0; i--) {
            data.splice(toRemove[i], 1);
        }
        data.push(...extra);
        return data;
    } catch (error) {
        console.error(error);
    }
    return [];
}

let servers = [];

const serverSelector = document.getElementById("serverSelector");

serverSelector.addEventListener("change", e => {
    const v = e.target.value;
    const server = servers[v];
    connect(server.url, server.port);
});

async function updateServers(jsonPath = "servers.json") {
    servers = await getServers(jsonPath);
    serverSelector.innerHTML = "";
    for (let i = 0; i < servers.length; i++) {
        const server = servers[i];

        const option = document.createElement("option");
        option.value = i;
        option.innerText = server.displayname;
        serverSelector.appendChild(option);
    }

    if (!connected) {
        connect(servers[0].url, servers[0].port);
    }
}

updateServers();

let gameWorker = new GameWorker(channel);
window.gameWorker = gameWorker;

const injector = new GraphicalWorld(gameWorker.world);

const app = new PIXI.Application({ resizeTo: window, antialias: true, backgroundColor: 0x330000 });
document.body.appendChild(app.view);
app.view.style.zIndex = 1;
app.view.style.position = "fixed";
app.view.style.top = 0;
app.view.style.left = 0;

app.stage.addChild(injector.pixiObj);

window.app = app;


// ------------------------------
let t1 = new Date().getTime();

const cameraProperties = {
    x: 0,
    y: 0,
    zoom: 1,
    offsetX: 0,
    offsetY: 0
}

let cameraShakeTime = 0.1;
let cameraShakeIntensity = 3;
let latestCameraShake = 0;
let latestMyBlob = null;

function updateMyBlob() {
    let myBlob = gameWorker.getMyBlob();
    if (myBlob !== null) {
        if (latestMyBlob !== myBlob) {
            latestMyBlob = myBlob;
            myBlob.on("attack", () => {
                //if (myBlob === latestMyBlob) executeCameraShakeEffect();
            });
            myBlob.on("damage", () => {
                //if (myBlob === latestMyBlob) executeCameraShakeEffect();
            });
            myBlob.on("deleted", () => {
                //if(myBlob === gameWorker.getMyBlob()) showMenu();
            });
        }
        return myBlob;
    }
    return null;
}

let cameraShakeResetTimeout = null;
function executeCameraShakeEffect() {
    let t = new Date().getTime();
    let elapsed = t - latestCameraShake;
    if (elapsed >= cameraShakeTime) {
        latestCameraShake = t;
        cameraProperties.offsetX = Math.random() * cameraShakeIntensity;
        cameraProperties.offsetY = Math.random() * cameraShakeIntensity;
        clearTimeout(cameraShakeResetTimeout);
        cameraShakeResetTimeout = setTimeout(() => {
            cameraProperties.offsetX = 0;
            cameraProperties.offsetY = 0;
        }, cameraShakeTime * 1.5);
    }
}

// Start animating
animate();
function animate() {
    let t2 = new Date().getTime();
    const delta = (t2 - t1) / 1000;
    t1 = t2;
    gameWorker.world.onTick(delta);

    //Render the stage
    app.renderer.render(app.stage);
    requestAnimationFrame(animate);

    const myBlob = gameWorker.getMyBlob();
    if (myBlob !== null) {
        cameraProperties.zoom = 1 + (window.innerHeight / 20) / myBlob.size;
        cameraProperties.x = myBlob.x * app.stage.scale.x;
        cameraProperties.y = myBlob.y * app.stage.scale.y;
    } else {
        cameraProperties.zoom = Math.min(window.innerWidth, window.innerHeight) / (gameWorker.world.size * 2);
        cameraProperties.x = 0;
        cameraProperties.y = 0;
    }

    let zoomDiff = cameraProperties.zoom - app.stage.scale.x;
    app.stage.scale.set(app.stage.scale.x + zoomDiff / 10);

    let targetPos = { x: -(cameraProperties.x) + window.innerWidth / 2, y: -(cameraProperties.y) + window.innerHeight / 2 };
    let posDiff = { x: targetPos.x - app.stage.position.x, y: targetPos.y - app.stage.position.y };
    let pDiv = 10;
    app.stage.position.set(app.stage.position.x + posDiff.x / pDiv + cameraProperties.offsetX * app.stage.scale.x, app.stage.position.y + posDiff.y / pDiv + cameraProperties.offsetY * app.stage.scale.y);

    updateMyBlob();
}

app.stage.position.set(window.innerWidth / 2, window.innerHeight / 2);

const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
const sentMouse = { x: 0, y: 0 };

const touchJoystick = document.getElementById("touchJoystick");
const touchJoystickStick = touchJoystick.querySelector(".stick");
let touchMode = false;
let touchControl = null;

let touchBlocker = 0;

setInterval(() => {
    if (touchBlocker <= 1) {
        touchBlocker = 0;
    } else {
        touchBlocker--;
    }
}, 1000);

document.addEventListener("mousemove", e => {
    if (!isMenuOpen && !touchBlocker) {
        touchMode = false;
        mouse.x = e.clientX;
        mouse.y = e.clientY;
    }
});


document.addEventListener("touchstart", e => {
    if (touchControl) return;
    if (!gameWorker.getMyBlob()) return;
    touchJoystickStick.style.left = `0px`;
    touchJoystickStick.style.top = `0px`;
    touchJoystick.style.left = `${e.changedTouches[0].clientX}px`;
    touchJoystick.style.top = `${e.changedTouches[0].clientY}px`;
    touchJoystick.style.display = "block";
    touchMode = true;
});

document.addEventListener("touchend", e => {
    touchControl = null;
    touchMode = true;
    touchBlocker = 3;
    touchJoystick.style.display = "none";
});

document.addEventListener("touchmove", e => {
    if (!gameWorker.getMyBlob()) return;
    if (e.changedTouches.length === 0) return;
    const x = e.changedTouches[0].clientX;
    const y = e.changedTouches[0].clientY;

    touchBlocker = 5;
    touchMode = true;
    mouse.x = 0;
    mouse.y = 0;
    if (touchControl) {
        const relativeX = x - touchControl.startX;
        const relativeY = y - touchControl.startY;

        let direction = Math.atan2(relativeX, relativeY);
        let max = touchJoystick.clientWidth / 2;
        let maxX = Math.sin(direction) * max;
        let maxY = Math.cos(direction) * max;

        let newX = Math.min(Math.abs(relativeX), Math.abs(maxX)) * Math.sign(relativeX);
        let newY = Math.min(Math.abs(relativeY), Math.abs(maxY)) * Math.sign(relativeY);

        touchJoystickStick.style.left = `${newX}px`;
        touchJoystickStick.style.top = `${newY}px`;

        touchControl.x = newX / max;
        touchControl.y = newY / max;
    } else {
        touchControl = { x: 0, y: 0, startX: x, startY: y };
    }
    //console.log(e);
});

setInterval(() => {
    if (touchControl || touchMode) return;
    const myBlob = gameWorker.getMyBlob();
    if (myBlob !== null && myBlob.pixiObj !== undefined) {
        const relPos = myBlob.pixiObj.toLocal(mouse);
        myBlob.setRelativeControlTarget(relPos.x, relPos.y);
        channel.emit("relativeControlTarget", { x: relPos.x, y: relPos.y });
    }
}, 1000 / 20);

/**
 * TEST UI CONTROLS
 */
let controlsDiv = document.createElement("div");
controlsDiv.style.position = "fixed";
controlsDiv.style.zIndex = 10;
controlsDiv.style.bottom = 0;
controlsDiv.style.right = 0;
controlsDiv.style.width = 200;

/*let respawnButton = document.createElement("button");
respawnButton.innerText = "RESPAWN";
controlsDiv.appendChild(respawnButton);*/

let debugViewButton = document.createElement("button");
debugViewButton.innerText = "TOGGLE DEBUG VIEW";
controlsDiv.appendChild(debugViewButton);

document.body.appendChild(controlsDiv);

/*respawnButton.addEventListener("click", () => {
    channel.emit("respawn");
});*/

debugViewButton.addEventListener("click", () => {
    toggleDebug();
});

let playButton = document.getElementById("playButton");
let usernameInput = document.getElementById("usernameInput");

let storedPlayerName = localStorage.getItem("playerName");
usernameInput.value = storedPlayerName !== null ? storedPlayerName : "";

function joinGame() {
    let playerName = usernameInput.value;
    console.log(`Joining as ${playerName}`);
    channel.emit("playerName", playerName);
    channel.emit("respawn");
    localStorage.setItem("playerName", playerName);
    hideMenu();
}
playButton.addEventListener("click", () => {
    joinGame();
});
usernameInput.addEventListener("keypress", e => {
    if (e.key === "Enter") {
        joinGame();
    }
});

/**
 * Nav buttons
 */
document.getElementById("fullscreenButton").addEventListener("click", () => {
    if (document.webkitIsFullScreen) {
        document.exitFullscreen();
    } else {
        document.body.requestFullscreen();
    }
});

document.getElementById("menuButton").addEventListener("click", () => {
    toggleMenu();
});

/**
 * MAIN MENU
 */
let isMenuOpen = true;

function showMenu() {
    isMenuOpen = true;
    mouse.x = window.innerWidth / 2;
    mouse.y = window.innerHeight / 2;
    touchControl = null;
    document.getElementById("menu").style.display = "block";
    let uiElements = document.getElementsByClassName("inGameUI");
    for (let i = 0; i < uiElements.length; i++) {
        let uiElement = uiElements[i];
        uiElement.style.display = "none";
    }
    console.log("Menu opened.");
}

function hideMenu() {
    isMenuOpen = false;
    document.getElementById("menu").style.display = "none";
    let uiElements = document.getElementsByClassName("inGameUI");
    for (let i = 0; i < uiElements.length; i++) {
        let uiElement = uiElements[i];
        uiElement.style.display = "block";
    }
    console.log("Menu closed.");
}

function toggleMenu() {
    if (isMenuOpen) {
        hideMenu();
    } else {
        showMenu();
    }
}

/**
 * Keyboard Events - UI
 */
window.addEventListener("keydown", e => {
    if (e.key === "Escape") {
        toggleMenu();
    }
});

/**
 * Ping Display
 */
setInterval(() => {
    gameWorker.socket.emit("ping", new Date().getTime());
}, 200);

let pingDisplay = document.getElementById("pingDisplay");
let prevPing = -1;
gameWorker.on("pong", timestamp => {
    let t = new Date().getTime();
    let ping = Math.round((t - timestamp) / 2);
    if (prevPing !== -1) {
        ping = (prevPing * 2 + ping) / 3;
        ping = Math.round(ping);
    }
    prevPing = ping;
    pingDisplay.innerText = `${ping}ms`;
});

/**
 * Death listener
 */
gameWorker.on("died", () => {
    showMenu();
});

/**
 * Info UI
 */
let topListItemsContainer = document.querySelector(".toplist .items");
let topListFirstItem = topListItemsContainer.querySelector(".item");
let topListItemTemplate = topListFirstItem.cloneNode(true);

topListItemsContainer.innerHTML = "";

function getTopListItems() {
    return topListItemsContainer.querySelectorAll(".item");
}

function updateTopListItem(item, number, name, score) {
    let numberElement = item.querySelector(".number");
    let nameElement = item.querySelector(".name");
    let scoreElement = item.querySelector(".score");
    numberElement.innerText = number;
    nameElement.innerText = name;
    scoreElement.innerText = score;
    return item;
}

function addTopListItem() {
    let item = topListItemTemplate.cloneNode(true);
    topListItemsContainer.appendChild(item);
}

function removeTopListItem() {
    if (getTopListItems().length > 0) {
        let items = getTopListItems();
        topListItemsContainer.removeChild(items[items.length - 1]);
    }
}

function setTopListItemsCount(n) {
    let currentN = getTopListItems().length;
    while (currentN > n) {
        removeTopListItem();
        currentN--;
    }
    while (currentN < n) {
        addTopListItem();
        currentN++;
    }
}

function fetchTopListItems(cb) {
    for (let i = 0; i < topListItemsContainer.childNodes.length; i++) {
        let item = topListItemsContainer.childNodes[i];
        cb(item);
    }
}

const sizeDisplay = document.getElementById("sizeDisplay");
const rankDisplay = document.getElementById("rankDisplay");
const playersCountDisplay = document.getElementById("playersCountDisplay");
const worldSizeDisplay = document.getElementById("worldSizeDisplay");

setInterval(() => {
    const myBlob = gameWorker.getMyBlob();
    if (!isMenuOpen) {
        if (myBlob !== null && myBlob.pixiObj !== undefined) {
            if (!touchMode && !touchControl) {
                if (sentMouse.x !== mouse.x || sentMouse.y !== mouse.y) {
                    const relPos = myBlob.pixiObj.toLocal(mouse);
                    myBlob.setRelativeControlTarget(relPos.x, relPos.y);
                    gameWorker.socket.emit("relativeControlTarget", { x: relPos.x, y: relPos.y });
                    sentMouse.x = mouse.x;
                    sentMouse.y = mouse.y;
                }
            } else if (touchControl) {
                const rX = touchControl.x * myBlob.size;
                const rY = touchControl.y * myBlob.size;
                myBlob.setRelativeControlTarget(rX, rY);
                gameWorker.socket.emit("relativeControlTarget", { x: rX, y: rY });
            } else {
                myBlob.setRelativeControlTarget(0, 0);
                gameWorker.socket.emit("relativeControlTarget", { x: 0, y: 0 });
            }
        }
    }

    if (isMenuOpen && sentMouse.x !== -1 && sentMouse.y !== -1) {
        sentMouse.x = -1;
        sentMouse.y = -1;
        gameWorker.socket.emit("relativeControlTarget", { x: 0, y: 0 });
    }

    /* Stats & toplist display */
    if (myBlob !== null) {
        sizeDisplay.innerText = `${Math.round(myBlob.size * 10) / 10} (max ${Math.round(myBlob.maxSize * 10) / 10})`;
    } else {
        sizeDisplay.innerText = "??";
    }

    let livingEntities = gameWorker.world.entities.filter(entity => {
        return entity.displayName !== null && entity.control === true;
    });

    let sortedLivingEntities = livingEntities.sort((e1, e2) => {
        if (e1.size > e2.size) {
            return -1;
        } else if (e1.size < e2.size) {
            return 1;
        } else {
            return 0;
        }
    });

    let myRank = "?";
    let topI = 0;
    while (topI < sortedLivingEntities.length && myRank === "?") {
        let entity = sortedLivingEntities[topI];
        if (entity === gameWorker.getMyBlob()) {
            myRank = (topI + 1) + ".";
        }
        topI++;
    }
    rankDisplay.innerText = myRank;

    playersCountDisplay.innerText = sortedLivingEntities.length;

    let top5 = sortedLivingEntities.slice(0, 5);

    setTopListItemsCount(top5.length);
    let top5i = 0;
    fetchTopListItems(itemElement => {
        let item = top5[top5i];
        updateTopListItem(itemElement, top5i + 1, item.displayName, Math.round(item.size * 10) / 10);
        top5i++;
    });

    worldSizeDisplay.innerText = gameWorker.world.size;

}, 1000 / 20);

/**
 * Initial
 */
showMenu();